import Box from '@mui/material/Box';
import { MenuBar } from '../components/MenuBar';
import { InviteUser, ManageJobsites, ManageUsers } from '../components/Administration';
import { WrapperCardWithTitle } from '../layouts/WrapperCardWithTitle';

export function UserAdminPage() {
  return (
    <Box display={'flex'}>
      <MenuBar />
      <Box
        sx={{
          paddingTop: '20px',
          paddingLeft: '1rem',
          width: `calc(100% - 2rem)`,
          position: 'absolute',
          top: 64,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <WrapperCardWithTitle
          sx={{ height: 'auto' }}
          contentSx={{ padding: 2 }}
          title='administration.userManagement.title'
        >
          <InviteUser />
        </WrapperCardWithTitle>
        <WrapperCardWithTitle contentSx={{ padding: 2 }} title='administration.locationManagement.title'>
          <ManageJobsites />
        </WrapperCardWithTitle>
        <WrapperCardWithTitle
          contentSx={{ padding: 2, minHeight: '50vh' }}
          title='administration.userPermissions.title'
        >
          <ManageUsers />
        </WrapperCardWithTitle>
      </Box>
    </Box>
  );
}
